var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('client-email-activity',{attrs:{"userId":_vm.userId}})],1)],1),_c('v-row',[_c('v-col',[_c('client-notes',{attrs:{"userId":this.userId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }